import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { Direction, SVGProps } from '../types';

type ChevronProps = SVGProps & { direction?: Direction };

const ChevronIcon = ({
  direction = 'left',
  ...props
}: ChevronProps): JSX.Element => {
  return <SpriteIcon spriteId="chevron-left" rotation={direction} {...props} />;
};

export { ChevronIcon };
